module.exports = __webpack_public_path__ + "static/assets/989d99155bdb2720680a8c09fb7c454e.svg";